import request from '../../../../../../helpers/request';
import { useMutation, useQueryClient } from 'react-query';
import { getQueryKeys } from '../../../../queries/queryKeys';
import { message } from 'antd';
import React from 'react';

const deleteTemplates = async ({ serviceCompanyId, houseAccessTypeId }) => {
  const res = await request.delete(
    `HousingStock/house/access_type`,
    { serviceCompanyId, houseAccessTypeId },
    'Не удалось удалить шаблон'
  );
  return res;
};

const useDeleteTemplates = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(deleteTemplates, {
    onSuccess: async (
      data,
      { houseAccessTypeId, serviceCompanyId, registrationTypeId }
    ) => {
      if (data !== 'Error') {
        if (data.success) {
          message.success('Шаблон успешно удален!', 2);
          queryClient.setQueryData(
            getQueryKeys.templates({ serviceCompanyId, registrationTypeId }),
            (oldData) =>
              oldData.filter((template) => template.id !== houseAccessTypeId)
          );
        } else {
          message.error(
            <div>
              <strong>{data.message}</strong>
              <div
                style={{
                  maxHeight: '100px',
                  overflow: 'auto',
                  marginTop: '5px',
                }}
              >
                {data.addresses.map((addres) => (
                  <div
                    key={addres}
                    style={{
                      display: 'flex',
                      justifyContent: 'start',
                      paddingLeft: '10px',
                      marginBottom: '5px',
                    }}
                  >
                    {addres}
                  </div>
                ))}
              </div>
            </div>,
            2
          );
        }
      }
    },
  });

  return {
    deleteAsync: mutation.mutateAsync,
    loading: mutation.isLoading,
  };
};

export { useDeleteTemplates };
